// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\(tabs)\\_layout.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\(tabs)\\index.tsx"); } },
  "./(tabs)/index.web.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\(tabs)\\index.web.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\_layout.tsx"); } },
  "./modal.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\modal.tsx"); } },
  "./privacy.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\privacy.tsx"); } },
  "./support.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\support.tsx"); } },
  "./terms.tsx": { enumerable: true, get() { return require("C:\\Maxify\\app\\terms.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;